// extracted by mini-css-extract-plugin
module.exports = {"s12cqlbn":"s12cqlbn"};